import useFartherEmployees from "../../../Entity/hooks/useFartherEmployees";
import { DEFAULT_PERSON_NAME } from "../../constants/common";
import useGetAdvisors from "./useGetAdvisors";
import useGetAdvisorsV2 from "./useGetAdvisorsV2";
const useGetTaskAdvisors = (version, auth) => {
    const advisorsQueryV1 = useGetAdvisors(version === "v1" ? auth : null);
    const advisorsQueryV2 = useGetAdvisorsV2(version === "v2" ? auth : null);
    const advisorsQuery = version === "v1" ? advisorsQueryV1 : advisorsQueryV2;
    const { data: advisors, hasError, isLoading } = advisorsQuery;
    const { data: employees } = useFartherEmployees("All", auth);
    const employeesById = employees?.advisors?.reduce((acc, employee) => {
        acc[employee.advisorId] = employee;
        return acc;
    }, {});
    if (isLoading) {
        return { data: undefined, isLoading, hasError };
    }
    if (hasError) {
        return {
            data: undefined,
            isLoading,
            hasError,
            error: "Failed loading Advisors",
        };
    }
    const advisorsWithProfile = advisors.advisors.map((advisor) => ({
        ...advisor,
        name: employeesById
            ? (employeesById[advisor.id]?.name ?? DEFAULT_PERSON_NAME)
            : advisor.name,
    }));
    return {
        data: {
            advisors: advisorsWithProfile,
        },
        isLoading,
        hasError,
    };
};
export default useGetTaskAdvisors;
//# sourceMappingURL=useGetTaskAdvisors.js.map